import { useNavigate, useParams } from "react-router-dom"
import { loadingActive, SplitScreenBackground } from "../components/Background";
import NavBar from "../components/NavBar";
import { useContext, useEffect, useState } from "react";
import { passwordPattern } from "../entries";
import { validatePassword } from "../utils";
import { requestCheckTokenStatus, requestSetupPassword } from "../requests/users_requests";
import { ContentContext } from "../contexts/ContentContext";
import { PasswordRulesModule } from "../components/AuthComponents";
import { PageHeader } from "../components/HeaderComponents";
import { useTranslation } from "react-i18next";
import { FaInfo } from "react-icons/fa";


export const SetupPassword = () => {
    const { t } = useTranslation('settings')
    const { openErrorModal } = useContext(ContentContext)

    const [password, setPassword] = useState("")
    const [rePassword, setRePassword] = useState("")
    const [dontMatch, setDontMatch] = useState(false)

    const [invalid, setInvalid] = useState(false);
    const [success, setSuccess] = useState(false)
    const navigator = useNavigate()
    const [tokenValid, setTokenValid] = useState(true)

    const { generated_token } = useParams()

    const [moduleOpen, setModuleOpen] = useState(true)

    const toggleModule = () => setModuleOpen(!moduleOpen)


    useEffect(() => {
        if (password !== rePassword && rePassword.length > 0) {
            setDontMatch(true)
        }
        else {
            setDontMatch(false)
        }
    }, [password, rePassword])


    useEffect(() => {
        requestCheckTokenStatus({ token: generated_token }).then((result) => {
            if (result.status === 200) {
                setTokenValid(true)
            }
            else {
                setTokenValid(false)
            }
        }).catch((error) => {
            setTokenValid(false)
        })
    }, [])


    const handleSubmit = (e) => {
        e.preventDefault()
        if (submitCondition) {
            loadingActive(true)
            requestSetupPassword({ token: generated_token, password: password })
                .then((result) => {
                    if (result.status === 200) {
                        setSuccess(true)
                        setPassword("")
                        setRePassword("")
                        loadingActive(false)
                    }
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(true)
                })
        }
    }

    const submitCondition = validatePassword(password) && validatePassword(rePassword) && (password === rePassword) && !success

    return (
        <>
            <SplitScreenBackground />
            <PageHeader pageTitle={t("Setup Password")} />
            <div className="flex flex-col items-center py-2  gap-5 pb-10">
                <NavBar />
                <main className="absolute top-0 bottom-0 flex flex-wrap justify-center items-center w-full mx-auto max-w-[1200px] z-9 p-1 sm:p-5">
                    {
                        tokenValid &&
                        <form
                            className="flex flex-col min-h-[310px] min-w-64 w-96 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 shadow-sm rounded-xl py-5 px-3 gap-1"
                            onSubmit={handleSubmit}
                        >
                            <h1 className="font-semibold text-2xl px-2">{t('Set Password')}</h1>

                            {
                                success &&
                                <div className="flex flex-col w-full px-2 text-green-700 dark:text-green-500">
                                    <span>{t('Your password has been set successfully.')}</span>
                                    <a href="/login" className="cursor-pointer underline">{t('Go to login page.')}</a>
                                </div>
                            }
                            {
                                !success &&
                                <>
                                    <div className="flex w-full px-2">
                                        <label className="form-control w-full">
                                            <div className="label">
                                                <span className="label-text text-base text-gray-800 dark:text-gray-300 font-semibold">
                                                    {t('New Password')}
                                                </span>
                                                <div className="relative md:hidden">
                                                    <button type="button" className="btn btn-sm border-primary dark:border-blue-300  bg-gray-100 dark:bg-gray-600 text-primary dark:text-blue-300 w-8 h-8 rounded-full" onClick={toggleModule}><FaInfo /></button>
                                                    {
                                                        moduleOpen &&
                                                        <div className="absolute ltr:right-0 rtl:left-0 bottom-8 z-[99999]">
                                                            <PasswordRulesModule password={password} />
                                                        </div>
                                                    }

                                                </div>
                                            </div>
                                            <input
                                                type="password"
                                                required={true}
                                                placeholder={t("Password")}
                                                value={password}
                                                pattern={passwordPattern}
                                                className="input input-bordered peer/p1 invalid:border-red-600 input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                }}
                                            />
                                            <p className="max-w-max invisible peer-invalid/p1:visible text-pink-600 dark:text-pink-500 text-sm">
                                                {t('Please enter a valid password.')}
                                                {/* Password should include at least 1 special character, upper case letter, lower case letter and a number (0-9). Must have more than 8 characters. */}
                                            </p>
                                        </label>
                                    </div>

                                    <div className="flex w-full px-2">
                                        <label className="form-control w-full">
                                            <div className="label">
                                                <span className="label-text text-base text-gray-800 dark:text-gray-300 font-semibold">
                                                    {t('Confirm New Password')}
                                                </span>
                                            </div>
                                            <input
                                                type="password"
                                                required={true}
                                                value={rePassword}
                                                pattern={passwordPattern}
                                                placeholder={t("Password")}
                                                className="input input-bordered invalid:border-red-600 input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                                                onChange={(e) => {
                                                    setRePassword(e.target.value);
                                                }}
                                            />
                                            <p className={`max-w-max ${password.length > 0 && dontMatch && rePassword.length > 0 ? "visible" : "invisible"}  text-pink-600 dark:text-pink-500 text-sm`}>
                                                {t('Passwords do not match.')}
                                            </p>
                                        </label>
                                    </div>



                                    <button
                                        type="submit"
                                        disabled={!submitCondition}
                                        className="btn bg-primary hover:bg-primary/90 border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 text-white font-semibold mx-[6px] mt-4"
                                    >
                                        {t('Submit')}
                                    </button>
                                </>
                            }

                            {
                                invalid &&
                                <h1 className="text-red-700 w-full text-center">{t('Invalid e-mail or password.')}</h1>
                            }
                        </form>

                    }
                    {
                        !tokenValid &&
                        <div className="flex flex-col min-w-64 w-96 bg-white shadow-sm rounded-xl py-5 px-3 gap-1">
                            <h1 className="font-semibold text-2xl px-2">{t('Set Password')}</h1>
                            <span className="px-2">{t('The token is invalid or has been expired.')}</span>
                        </div>
                    }
                    {
                        tokenValid && !success &&
                        <div className="relative h-full hidden md:flex">
                            <div className="absolute top-1/2 -translate-y-1/2 ltr:left-1 rtl:right-1">
                                <PasswordRulesModule password={password} />
                            </div>
                        </div>
                    }
                </main>
            </div>
        </>
    )
}